import { ThemeProvider } from 'components/features/theme/ThemeProvider/ThemeProvider'
import { FC, useEffect } from 'react'
import styles from 'components/features/creditCard/creditCardComparisonChart/Controls/Controls.styl'
import { FormProvider, useForm } from 'react-hook-form'
import { maskCurrencyPositive, maskPercentNeg20To20 } from 'components/atoms/inputs/maskedInput'
import { ControlPresetController } from 'components/features/creditCard/creditCardComparisonChart/ControlPreset/ControlPreset'

type ControlsProps = {
  onChange: (params: { spending: number, performance: number }) => void
}
export const Controls: FC<ControlsProps> = (props) => {
  const { onChange } = props
  const formContext = useForm({
    defaultValues: {
      spending: 1000,
      performance: 10,
    },
  })
  const { watch } = formContext
  const [spending, performance] = watch(['spending', 'performance'])

  useEffect(() => {
    onChange({
      spending: +spending,
      performance: +performance,
    })
  }, [spending, performance, onChange])

  return (
    <FormProvider { ...formContext }>
      <ThemeProvider futureFieldTitle='income'>
        <div className={ styles.controls }>
          <div className={ styles.control }>
            <ControlPresetController
              label='Card Spending'
              name='spending'
              mask={ maskCurrencyPositive }
              inputMode='numeric'
              min={ 500 }
              max={ 5000 }
              step={ 100 }
              mode='spending'
            />
          </div>
          <div className={ styles.control }>
            <ControlPresetController
              label='Bitcoin Performance'
              name='performance'
              mask={ maskPercentNeg20To20 }
              inputMode='decimal'
              min={ -20 }
              max={ 20 }
              step={ 1 }
              mode='performance'
            />
          </div>
        </div>
      </ThemeProvider>
    </FormProvider>
  )
}
